<template>
	<a-dropdown :trigger="['click']" placement="bottomLeft">
		<div :class="$style.searchContainer">
			<i class="fe fe-search" :class="$style.searchIcon"></i>
			<input
				v-model="search"
				:class="$style.searchInput"
				type="text"
				:placeholder="$t('topBar.typeToSearch')"
			/>
		</div>
		<div
			slot="overlay"
			class="card air__utils__shadow width-250"
			v-if="result.length > 0"
		>
			<div class="card-body p-1">
				<div class="pt-3 px-2 pb-3">
					<vue-custom-scrollbar :style="{ maxHeight: '300px' }">
						<ul class="list-unstyled">
							<li
								:class="$style.item"
								v-for="(account, index) in result"
								:key="index"
							>
								<router-link
									:to="'/account/' + account.id + '/profiles'"
									:class="$style.itemLink"
								>
									<div class="text-center mr-3">
										<a-icon v-if="account.typeId === 1" type="user" />
										<a-icon v-if="account.typeId !== 1" type="home" />
									</div>
									<div>
										<div class="text-blue">{{ account.name }}</div>
										<div class="text-muted">{{ account.typeName }}</div>
									</div>
								</router-link>
							</li>
						</ul>
					</vue-custom-scrollbar>
				</div>
			</div>
		</div>
		<div slot="overlay" class="card air__utils__shadow" v-else>
			<div class="card-body p-1">
				<div class="pt-3 px-2 pb-3">
					<div class="text-muted">No result</div>
				</div>
			</div>
		</div>
	</a-dropdown>
</template>

<script>
import { ACCOUNT as ACCOUNT_ACTIONS } from '@/store/actions'
import { mapActions } from 'vuex'
import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
	components: {
		vueCustomScrollbar,
	},
	created() {
		this.searchAccount({ name: '' }).then(e => {
			this.result = e
		})
	},
	data: function() {
		return {
			search: '',
			result: [],
		}
	},
	methods: {
		...mapActions({
			searchAccount: ACCOUNT_ACTIONS.SEARCH,
			loadAccount: ACCOUNT_ACTIONS.LIST,
		}),
	},
	watch: {
		search: function(val) {
			this.loadAccount()
			this.searchAccount({ name: val }).then(e => {
				this.result = e
			})
		},
	},
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
